<template>
    <div>
        <flash-error ref="flashError"></flash-error>
        <progress-bar percentages="80"></progress-bar>
        <section id="service-section" class="py-2 mobile-container">
            <div class="d-flex align-items-center justify-content-between text-light">
                <div>Opsummering</div>
            </div>
        </section>
        <section id="text-section" class="mobile-container bg-light">
            <div class="py-2">
                <div class="mb-2"><strong>Dine valg:</strong></div>
                <div class="mb-2" v-if="additionalServicesProp[changeAddressKey] &&
                 additionalServicesProp[changeAddressKey].enabled"
                >
                    <div>{{ additionalServicesProp[changeAddressKey].value.name }}</div>
                    <div>
                        {{ additionalServicesProp[changeAddressKey].value.street }},
                        {{ additionalServicesProp[changeAddressKey].value.zip }}
                        {{ additionalServicesProp[changeAddressKey].value.city }},
                        <span v-if="booking.pickup_address.country">{{ booking.pickup_address.country.name }}</span>
                    </div>
                    <div>{{ additionalServicesProp[changeAddressKey].value.phone }}</div>
                    <div v-if="additionalServicesProp[changeAddressKey].price > 0">
                        (+{{ additionalServicesProp[changeAddressKey].price }} kr.)
                    </div>
                </div>
                <div class="mb-2" v-else>
                    <div>{{ booking.pickup_address.name }}</div>
                    <div>
                        {{ booking.pickup_address.street }},
                        {{ booking.pickup_address.zip }}
                        {{ booking.pickup_address.city }},
                        <span v-if="booking.pickup_address.country">{{ booking.pickup_address.country.name }}</span>
                    </div>
                    <div>{{ booking.pickup_address.phone }}</div>
                </div>
                <div class="mb-2">
                    <div>
                        <div v-if="booking.pickup_trip && booking.pickup_trip.time_communicated">Afhentningsdato</div>
                        <div v-else>Afhentningstidspunkt</div>
                        <div class="d-flex align-items-center"
                             v-if="booking.pickup_trip && booking.pickup_trip.time_communicated">
                            <span class="material-icons-outlined small cursor-pointer pr-1">event</span>
                            <span v-if="additionalServicesProp[newDeliveryDateKey] &&
                            additionalServicesProp[newDeliveryDateKey].enabled">
                                {{ additionalServicesProp[newDeliveryDateKey].value.replace(/\(.*/, '') }}
                                <span v-if="additionalServicesProp[newDeliveryDateKey].price > 0">
                                    (+{{ additionalServicesProp[newDeliveryDateKey].price }} kr.)
                                </span>
                            </span>
                            <span v-else>
                                {{ formatDate(autopushedDate ? autopushedDate : booking.pickup_end, 'DD-MM-yyyy') }}
                            </span>
                        </div>
                        <div class="d-flex align-items-center"
                             v-if="pickupStartTime || pickupEndTime">
                            <span class="material-icons-outlined small cursor-pointer pr-1">schedule</span>
                            <span>{{ pickupStartTime }} - {{ pickupEndTime }}</span>
                            <span class="ml-1" v-if="additionalServicesProp[shorterTimeIntervalKey] &&
                             additionalServicesProp[shorterTimeIntervalKey].enabled &&
                              additionalServicesProp[shorterTimeIntervalKey].price > 0"
                            >
                                (+{{ additionalServicesProp[shorterTimeIntervalKey].price }} kr.)
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="totalPrice > 0" class="d-flex align-items-start justify-content-between">
                    <div class="mr-4">
                        <input type="checkbox"
                               id="accept-terms"
                               v-model="acceptTerms"
                        >
                    </div>
                    <div>
                        <label for="accept-terms" class="mb-4">
                            Jeg godkender, at ydelsen udføres inden min 14 dages fortrydelsesret udløber,
                            og at fortrydelsesretten ophører, når ydelsen er påbegyndt.
                            Læs mere i
                            <a @click.prevent="openModalIframe('Handelsbetingelser', 'https://steptransport.dk/handelsbetingelser.html')"
                               href="#"
                            >handelsbetingelserne</a>.
                        </label>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <button
                        class="btn btn-primary"
                        @click="openModalIframe('Kundeguide', 'https://www.steptransport.dk/kundeguide.html')"
                    >Hjælp</button>
                    <button class="btn btn-success" :disabled="totalPrice > 0 && !acceptTerms" @click="goNext">
                        <span v-if="totalPrice > 0">Bekræft og betal {{ totalPrice }} kr.</span>
                        <span v-else>Bekræft</span>
                    </button>
                </div>
            </div>
        </section>
        <back-section :url="prevUrl" type="2"></back-section>

        <modal-iframe
            :title="modalTitle"
            :src="modalSrc"
            ref="modal-iframe"
            @toggleActiveIframeModalInterval="toggleActiveIframeModalInterval"
        ></modal-iframe>
        <div v-if="activeIframeModalInterval" class="modal-backdrop fade show"></div>

    </div>

</template>

<script>
import ProgressBar from "../reusable/ProgressBar.vue";
import BackSection from "../reusable/BackSection.vue";
import ModalIframe from "../reusable/ModalIframe.vue";
import FlashError from "../reusable/FlashError.vue";
import dateTimeMixin from "../../../mixins/dateTimeMixin";
export default {
    name: "CmfPickupStep4",
    components: {FlashError, ModalIframe, ProgressBar, BackSection},
    mixins: [dateTimeMixin],
    props: {
        booking: {type: Object, required: true},
        nextUrl: {type: String, required: true},
        prevUrl: {type: String, required: true},
        applyChangesUrl: {type: String, required: true},
        additionalServicesProp: {type: Object|Array, required: true},
        changeAddressKey: {type: String, required: true},
        newDeliveryDateKey: {type: String, required: true},
        shorterTimeIntervalKey: {type: String, required: true},
        configurations: {type: Object, required: true},
        autopushedDate: {type: String, required: false, default: ''}
    },
    data() {
        return {
            activeIframeModalInterval: false,
            totalPrice: 0,
            acceptTerms: false,
            pickupStartTime: this.getPickupTime(
                this.booking,
                'start',
                this.configurations['default_time_from_pickup'].value
            ),
            pickupEndTime: this.getPickupTime(
                this.booking,
                'end',
                this.configurations['default_time_to_pickup'].value
            ),
            modalTitle: '',
            modalSrc: '',
            show: false
        }
    },
    created() {
        this.calculateTotalPrice(this.additionalServicesProp);

        if (this.additionalServicesProp[this.shorterTimeIntervalKey] &&
            this.additionalServicesProp[this.shorterTimeIntervalKey].enabled
        ) {
            if (this.additionalServicesProp[this.shorterTimeIntervalKey].value['when'] === 'Before') {
                this.pickupEndTime = this.additionalServicesProp[this.shorterTimeIntervalKey].value['time'];
                this.pickupStartTime = this.configurations['default_time_from_pickup']['value'];
            } else {
                this.pickupStartTime = this.additionalServicesProp[this.shorterTimeIntervalKey].value['time'];
                this.pickupEndTime = this.configurations['default_time_to_pickup']['value'];
            }
        }
    },
    methods: {
        goNext() {
            axios.post(this.applyChangesUrl, {totalPrice: {key: 'totalPrice', value: this.totalPrice}})
                .then((response) => {
                    window.location.href = this.nextUrl;

                }).catch(error => {
                this.$refs.flashError.flashError(error);
            });

        },
        openModalIframe(title, src) {
            this.modalTitle = title;
            this.modalSrc = src;
            this.$refs["modal-iframe"].toggleModal();
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
        calculateTotalPrice(obj) {
            for (let key in obj) {
                if (typeof obj[key] === 'object' && obj[key].enabled) {
                    this.totalPrice += obj[key].price ? parseFloat(obj[key].price) : 0;
                }
            }
        },
    },
}

</script>

<style scoped>

</style>
